export default function Products() {
  const products = [
    {
      name: 'VPN',
      description: 'Our VPN application provides military-grade encryption to protect your online privacy and security. With servers worldwide, enjoy fast and secure browsing on your iOS device. Features include automatic connection, kill switch protection, and zero-logging policy to ensure your data remains private.',
      icon: 'ri-shield-check-line',
      gradient: 'from-[#00D9FF] to-[#0066FF]',
      image: 'https://public.readdy.ai/ai/img_res/0a7051e1becf26839c8da05aeaf42b5b.jpg',
    },
    {
      name: 'Cleaner',
      description: 'Keep your iOS device running at peak performance with our intelligent Cleaner app. Automatically identifies and removes junk files, optimizes storage, and manages duplicate photos. Features smart cleaning algorithms, battery optimization tools, and detailed storage analytics to help you maintain a fast and efficient device.',
      icon: 'ri-brush-line',
      gradient: 'from-[#10B981] to-[#00D9FF]',
      image: 'https://readdy.ai/api/search-image?query=modern%20phone%20cleaning%20optimization%20icon%20with%20broom%20and%20sparkles%2C%20clean%20minimalist%20design%20on%20simple%20light%20background%2C%20professional%20tech%20illustration%20with%20green%20and%20cyan%20gradient%20colors%2C%203D%20rendered%20style%20with%20soft%20shadows%2C%20device%20performance%20concept%2C%20premium%20quality%20digital%20artwork&width=400&height=400&seq=cleaner-product-icon-001&orientation=squarish',
    },
  ];

  return (
    <section id="products" className="py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="text-center space-y-6 mb-20">
          <span className="text-sm font-bold text-[#00D9FF] uppercase tracking-[3px] whitespace-nowrap">
            Our Products
          </span>
          <h3 className="text-5xl lg:text-6xl font-bold text-black">
            Solutions That Matter
          </h3>
          <p className="text-lg text-[#718096] max-w-[560px] mx-auto">
            Discover our flagship iOS applications designed to enhance security and optimize performance for millions of users worldwide.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-product-shop>
          {products.map((product, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl p-10 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 cursor-pointer border border-gray-100"
            >
              <div className="space-y-8">
                <div className="flex items-center justify-center">
                  <div className={`w-24 h-24 rounded-full bg-gradient-to-br ${product.gradient} flex items-center justify-center shadow-lg`}>
                    <i className={`${product.icon} text-4xl text-white`}></i>
                  </div>
                </div>

                <div className="text-center">
                  <h4 className="text-3xl font-bold text-black mb-4">
                    {product.name}
                  </h4>
                  <p className="text-base text-[#718096] leading-relaxed">
                    {product.description}
                  </p>
                </div>

                <div className="relative h-48 rounded-2xl overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-contain p-8"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}